import { ImageWithTextSection } from '@quicktools/shared-components';
import IImageWithTextSection from '@quicktools/shared-components/components/landingPages/ImageWithTextSection/types';

function ImageSection({ props }) {
  const imageSectionItems: IImageWithTextSection[] = [
    {
      title: props?.title,
      imageWidth: props?.imageWidth,
      imgSrc: props?.imgSrc,
      imgAlt: props.imgAlt,
      imageRight: props?.imageRight,
      children: (
        <div>
          {props?.children?.paragraph}

          {props.children.list && (
            <ul style={{ marginTop: 24, marginLeft: 30 }}>
              {props.children.list.map((item, index) => (
                <li key={`item-${index}`}> {item}</li>
              ))}
            </ul>
          )}

          {props?.children?.additionalText && (
            <div style={{ marginTop: 24 }}>{props?.children?.additionalText}</div>
          )}
        </div>
      ),
    },
  ];

  return (
    <>
      {imageSectionItems.map((params, index) => (
        <ImageWithTextSection {...params} key={index} />
      ))}
    </>
  );
}

export default ImageSection;
